const list = [
  { id: 'product1', name: 'PERtinence Retrait' },
  { id: 'product2', name: 'Capitalisation Vie plus PP' },
  { id: 'product3', name: 'Patrimoine Vie Plus' },
  { id: 'product4', name: 'Avenir Vie Plus' },
  { id: 'product5', name: 'VIE PLUS IMPACT' }
]

const getDefaultState = () => {
  return {
    list
  }
}

const state = getDefaultState()

export default () => ({
  namespaced: true,
  state
})
